import type { ReactNode } from "react";
import { MdErrorOutline } from "react-icons/md";
import styles from "./ErrorPanel.module.scss";

export const ERROR_PANEL_DEFAULT_NOTE = "If the error persists, contact Merito.";

export interface ErrorPanelProps {
  /** What went wrong. */
  title: ReactNode;
  /** What to do about it. */
  description?: ReactNode;
  /** Omit for the default contact line; pass null to drop the line and its divider. */
  note?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export const ErrorPanel = ({
  title,
  description,
  note,
  icon = <MdErrorOutline aria-hidden="true" />,
  className = "",
}: ErrorPanelProps): JSX.Element => {
  const footNote = note === undefined ? ERROR_PANEL_DEFAULT_NOTE : note;

  return (
    <div className={`${styles.panel} ${className}`} role="alert">
      <div className={styles.headline}>
        <span className={styles.icon}>{icon}</span>
        <p className={styles.title}>{title}</p>
      </div>
      {description ? <p className={styles.description}>{description}</p> : null}
      {footNote ? (
        <>
          <span className={styles.divider} />
          <p className={styles.note}>{footNote}</p>
        </>
      ) : null}
    </div>
  );
};

export default ErrorPanel;
